import styled from '@emotion/styled';
import { Z_SCALE } from 'radiance-ui/lib/constants';

export const ModalContainer = styled.div<{
  isOpen: boolean;
  distanceFromTop: string;
  transitionDuration: string;
  isFullScreen: boolean;
}>`
  background: ${({ theme }) => theme.COLORS.white};
  /* Only a full-screen modal stretches to the viewport. A drop-down panel
     hugs its content, so its bottom stays auto. */
  bottom: ${({ isOpen, isFullScreen }) =>
    isOpen && isFullScreen ? '0' : 'auto'};
  justify-content: space-between;
  left: 0;
  opacity: 0;
  overflow: auto;
  position: fixed;
  right: 0;
  top: ${({ distanceFromTop }) => distanceFromTop};
  transform: translateY(-100%);
  transition: ${({ transitionDuration }) =>
    `opacity ${transitionDuration} ease-in-out, transform ${transitionDuration} ease-in-out`};
  z-index: ${Z_SCALE.modal};

  ${({ isOpen }) =>
    isOpen &&
    `
    opacity: 1;
    transform: translateY(0);
  `};

  ${({ isFullScreen, distanceFromTop }) =>
    isFullScreen &&
    `
    height: calc(100vh - ${distanceFromTop});
    max-height: calc(100vh - ${distanceFromTop});
  `};

  ${({ isFullScreen, distanceFromTop }) =>
    !isFullScreen &&
    `
    max-height: calc(100vh - ${distanceFromTop});
  `};
`;
